import { BASE_URL as PRODUCTION_BASE_URL, HOST as PRODUCTION_HOST, PENDO_API_KEY as DEVELOPMENT_API_KEY } from '../.env.production.js';
import { BASE_URL as DEVELOPMENT_BASE_URL, HOST as DEVELOPMENT_HOST, PENDO_API_KEY as PRODUCTION_PENDO_API_KEY } from '../.env.development.js';

const BASE_URL = (process.env.NODE_ENV === 'development' ? DEVELOPMENT_BASE_URL : PRODUCTION_BASE_URL);
const HOST = (process.env.NODE_ENV === 'development' ? DEVELOPMENT_HOST : PRODUCTION_HOST);
const PENDO_API_KEY = (process.env.NODE_ENV === 'development' ? DEVELOPMENT_API_KEY : PRODUCTION_PENDO_API_KEY);

if (!BASE_URL) {
    throw new Error('BASE_URL is not defined');
} else if (!HOST) {
    throw new Error('HOST is not defined');
}

export const apiUrl = BASE_URL;
export const host = HOST;
export const version = "1";
export const pendoApiKey = PENDO_API_KEY;
export const applicationUrl = window.location.origin;

function getEnvironment() {
    // Extract hostname pattern for environment detection
    var hostname = window.location.hostname;
    if (hostname === 'roi-ace.leveldata.com') {
        return 'PROD';
    }
    else if (hostname === 'demo.roi-ace.leveldata.com') {
        return 'DEMO';
    }
    else if (hostname === 'staging.roi-ace.leveldata.com') {
        return 'STAGING';
    }
    else if (hostname === 'dev.roi-ace.leveldata.com' || hostname === 'ace3.glimpsek12.com') {
        return 'DEV';
    }

    return 'LOCAL';
}

export const environment = getEnvironment();